// Dawn theme - Size Chart Toggle Script
document.addEventListener("click", e => {
  const btn = e.target.closest("[data-unit]");
  if (!btn) return;

  const unit = btn.dataset.unit;
  const container = btn.closest(".size-chart-container");
  if (!container) return;

  // ボタンの見た目更新
  container.querySelectorAll("[data-unit]").forEach(b => {
    const active = b.dataset.unit === unit;
    b.style.backgroundColor = active ? "#000" : "#fff";
    b.style.color = active ? "#fff" : "#333";
  });

  // テーブルの数値更新
  container.querySelectorAll("[data-cm]").forEach(cell => {
    const cm = cell.getAttribute("data-cm");
    const inch = cell.getAttribute("data-inch");
    if (cm && inch) {
      cell.textContent = unit === "cm" ? cm : inch;
    }
  });
});
